<template>
    <div class="bg-lighter">
        <div class="header">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-end">
                        <div class="col-auto">
                            <i class="fe fe-chevron-left h1" />
                        </div>
                        <div class="col">
                            <h6 class="header-pretitle">{{$t('Patient')}}</h6>
                            <h1 class="header-title">Aziz Yusupov</h1>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-outline-success">
                                <i class="fe fe-plus" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-lg-6 col-md-6 col-sm-6">
                    <!-- Card -->
                    <div class="card card-fill">
                        <div class="card-header">
                            <!-- Title -->
                            <h4 class="card-header-title">15 Января 2020</h4>
                            <a class="small" href="#!">View all</a>
                        </div>
                        <div class="card-body">
                            <div class="list-group list-group-flush list-group-activity my-n3">
                                <div class="list-group-item">
                                    <div class="row">
                                        <div class="col-auto">
                                            <!-- Avatar -->
                                            <div class="avatar avatar-sm">
                                                <div
                                                    class="avatar-title font-size-lg bg-primary-soft rounded-circle text-primary small"
                                                >22</div>
                                            </div>
                                        </div>
                                        <div class="col ml-n2">
                                            <h5 class="mb-1">Лечение кариеса каналов</h5>
                                            <p
                                                class="small text-gray-700"
                                            >Sent to all 1,851 subscribers over a 24 hour period</p>
                                            <avatar class="mr-1 hover" />
                                            <avatar class="mr-1 hover" />
                                            <avatar />
                                        </div>
                                    </div>
                                    <!-- / .row -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="col-12 col-lg-6 col-md-4 col-xl-4"
                    v-for="appointment in appointments"
                    :key="appointment._id"
                >
                    <div class="card" v-if="false">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-auto h2">15:00</div>
                                <div class="col">
                                    <span class="h2 mb-0">
                                        {{appointment.customer.firstName}}
                                        {{appointment.customer.lastName}}
                                    </span>
                                    <div class="text-muted">{{appointment.services}}</div>
                                </div>
                                <div class="col-auto">
                                    <status iconOnly="true" :status="appointment.status" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script >


import Money from "@/components/Money";
import Avatar from "@/components/Avatar";
import MoneyField from "@/components/MoneyField";
import { mapActions, mapGetters, mapState } from "vuex";
import debounce from 'lodash/debounce';
import DiscountField from "@/Pages/Sales/DiscountField";
import FindCustomer from '@/components/FindCustomer'
import Status from '@/components/StatusBadge'

export default {
    components: {
        Avatar,
        MoneyField,
        DiscountField,
        FindCustomer,
        Money,
        Status
    },
    mounted() { },
    data() {
        return {
            appointments: [
                {
                    _id: 11,
                    customer: {
                        firstName: 'Another',
                        lastName: 'Bnother',
                    },
                    services: 'Удаление папилом',
                    status: 'new'
                },
                {
                    _id: 12,
                    customer: {
                        firstName: 'Aziz',
                        lastName: 'Yusupov',
                    },
                    services: 'Чистка лица',
                    status: 'arrived'
                },
                {
                    _id: 13,
                    customer: {
                        firstName: 'Алишер',
                        lastName: 'Эшматов',
                    },
                    services: 'Массаж волосистой части головы от супер доктора и его помощника',
                    status: 'started'
                },
                {
                    _id: 1,
                    customer: {
                        firstName: 'Another',
                        lastName: 'Bnother',
                    },
                    services: 'Удаление папилом',
                    status: 'new'
                },
                {
                    _id: 2,
                    customer: {
                        firstName: 'Aziz',
                        lastName: 'Yusupov',
                    },
                    services: 'Чистка лица',
                    status: 'confirmed'
                },
                {
                    _id: 3,
                    customer: {
                        firstName: 'Алишер',
                        lastName: 'Эшматов',
                    },
                    services: 'Массаж волосистой части головы от супер доктора и его помощника',
                    status: 'notConfirmed'
                },
            ]


        }
    },
    computed: {

    },
    watch: {

    },

    created() {
        /* Preload some data */


    },

    methods: {


    }
};
</script>

